export default "__VITE_ASSET__a4Pjdrue__"